import { render } from "./BackupList.vue?vue&type=template&id=5fd48ba9"
import script from "./BackupList.vue?vue&type=script&lang=js"
export * from "./BackupList.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__